/** Why a day takes no tracking. The tooltip of a disabled "+" and the locked tab of the dashboard show it. */
export const noTrackingDayReason = "Für diesen Tag existiert kein Staffing,\nfür das Erfassungen getätigt werden können";
